'use strict';

class AjaxManager {
    constructor(config = {}) {
        this.config = {
            url: selectrum.ajax_url,
            method: 'POST',
            data: {
                //ajax_nonce: selectrum.ajax_nonce,
            },
            ...config
        };
    }

    request(args) {
        const settings = $.extend(true, {}, this.config, {
            beforeSend: function () {
                if (args.onBeforeSend && args.onBeforeSend.call(args) === false) {
                    return false;
                }

                if ( args.showLoader ) {
                    popupManager.loading();
                }
            },
            success: function (response) {
                if ( response.success ) {
                    if (args.onSuccess && args.onSuccess.call(this, response, args) === false) {
                        if ( args.showLoader ) {
                            popupManager.close();
                        }
                        return false;
                    }

                    if ( response.data ) {
                        if ( response.data.type ) {
                            switch ( response.data.type ) {
                                case 'reload':
                                    location.reload();
                                    break;
                                case 'redirect':
                                    location.href = response.data.redirect_url;
                                    break;
                                case 'popup':
                                    popupManager.setContent( response.data.content );
                                    break;
                                case 'alert':
                                    alert( response.data.content );
                                    break;
                                default:
                                    popupManager.setContent( response.data.content );
                                    break;
                            }
                        } else if ( response.data.content ) {
                            popupManager.setContent( response.data.content );
                        }
                    }
                } else {
                    if (args.onError && args.onError.call(this, response, args) === false) {
                        return false;
                    }

                    if ( response.data && response.data.content ) {
                        popupManager.setContent( response.data.content );
                    } else {
                        popupManager.setContent( selectrum.default_error_message );
                    }
                }
            },
            error: function (xhr, status, error) {
                popupManager.setContent( selectrum.default_error_message );
                console.log( error );
            },
            complete: function () {
                if (args.onComplete && args.onComplete.call(this, args) === false) {
                    return false;
                }
            }
        }, args);
        jQuery.ajax(settings);
    }
}

window.ajaxManager = new AjaxManager();
